import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const videoSwiper = new Swiper( '.video-swiper__wrapper', {
	slidesPerView: 1,
	spaceBetween: 32,
	navigation: {
		nextEl: '.button-next',
		prevEl: '.button-prev',
	},
	keyboard: {
		enabled: true,
	},
	a11y: true,
} );

videoSwiper.on( 'slideChange', ( swiper ) => {
	const progressBar = swiper.el.querySelector( '.progress__bar' );
	const currentSlideNumber = swiper.el.querySelector( '.swiper-count__current' );
	const progress = ( swiper.activeIndex + 1 ) / swiper.slides.length * 100;

	progressBar.style.inlineSize = `${progress}%`;
	currentSlideNumber.innerHTML = `${swiper.activeIndex + 1}`;

	const iframes = swiper.slides[swiper.previousIndex].querySelectorAll( 'iframe[src*="youtube.com"]' );
	iframes.forEach( ( iframe ) => {
		iframe.src = iframe.src;
	} );
} );